import { lazy } from 'react'

const My = lazy(() => import('./My'))
const Profile = lazy(() => import('./Profile'))
const History = lazy(() => import('./History'))
const Favorites = lazy(() => import('./Favorites'))
const Wallet = lazy(() => import('./Wallet'))
const Bonuses = lazy(() => import('./Bonuses'))

export const AccountRouters = [
  {
    index: true,
    element: <My />,
  },
  {
    path: 'wallet/:type?',
    element: <Wallet />,
  },
  {
    path: 'history/:type?',
    element: <History />,
  },
  {
    path: 'profile',
    element: <Profile />,
  },
  {
    path: 'favorites',
    element: <Favorites />,
  },
  {
    path: 'bonuses',
    element: <Bonuses />,
  }
]
